var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretakerIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -1808)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(786 1808)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(831 1859)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(977.6 2321.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.007,14.1C12.987,14.1.8,23.339.8,34.789a17.4,17.4,0,0,0,5.215,12.13L1.65,54.911a1.211,1.211,0,0,0,1.53,1.7L13.837,52.36a33.354,33.354,0,0,0,14.171,3.061c15.021,0,27.207-9.239,27.207-20.689S43.028,14.1,28.007,14.1ZM43.935,44.538h-.17a1.7,1.7,0,0,1,0-3.4h.17a1.7,1.7,0,0,1,0,3.4Zm0-6.235H11.513a1.7,1.7,0,0,1,0-3.4H43.992a1.67,1.67,0,0,1,1.7,1.7A1.718,1.718,0,0,1,43.935,38.3Zm0-6.8H11.513a1.7,1.7,0,0,1,0-3.4H43.992a1.67,1.67,0,0,1,1.7,1.7A1.718,1.718,0,0,1,43.935,31.5Z",
    transform: "translate(-182.4 -512)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretakerIcon3);
export default __webpack_public_path__ + "static/media/caretaker-icon3.77b6b4c0424334a1b0677f03768f1781.svg";
export { ForwardRef as ReactComponent };